jQuery(document).on('ready', function(){
	BASE.onReady();
	UPDATE.onReady();
	FORMS.onReady();
	MEDIAUPLOAD.onReady();
	YOUTUBE.onReady();
	TOGGLE.onReady();
});




var BASE = {
	onReady: function(){
		BASE.breakpoint = 768;

		BASE.initBrowserSupport();
		BASE.initSlick();
		// BASE.setVideoContent();
		BASE.setVideoContent_v2();
		// BASE.setProgContent();
		BASE.setProgContent_v2();
		BASE.setProgNav();

		if (jQuery(window).width() < BASE.breakpoint )
			BASE.setMobileProgNav();

		jQuery('.programm-item').on('click', '.link-text', BASE.setProgContent_v2);
		jQuery('.programm-item').on('click', '.link-video', BASE.setVideoContent_v2);
		jQuery('.menu').on('click', 'a.programm.has-subnav, .layer', BASE.showProgNav);
		jQuery('.menu').on('click', 'a.has-sublayer', BASE.showProgSubLayer);
		jQuery('.is-menu-mobile').on('click', 'a.has-sublayer', BASE.showProgSubLayer);
		jQuery('.menu').on('click', '.layer a', BASE.triggerProgNav);
		jQuery('.main-menu').on('click', '#burger, .menu-title', BASE.showMobileNav);

		jQuery(".menu .title:contains('®')").html(function(_, html) {
   			return html.replace(/(®)/g, '<sup>$1</sup>');
		});
	},



	getUser: function(){
		var dfd = jQuery.Deferred();

		jQuery.ajax({
            url: kdkJS.ajaxurl,
            type:'POST',
            data: "action=kdk_get_user", 
            success: function(response){
            	var regex    = new RegExp(/[0]$/);
				var response = response.replace(regex, '');

            	BASE.userName = response;

            	dfd.resolve();
            },
            error : function(jqXHR, textStatus, errorThrown){
                console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            }
        });

        return dfd.promise();
	},


	
	initBrowserSupport: function(){
		if (BrowserDetect.browser != 'IE' && typeof(Storage) !== "undefined") {
		    jQuery('.update').addClass('is-hidden');
		}
	},


	
	setVideoContent_v2: function(){
		if ( jQuery('.video-parent.is-single').length >= 1 ) { // FB

			jQuery.each( jQuery('.video-parent.is-single'), function(i,v){
				let source = v;
				let hash = jQuery('.video-ghost', source).attr('data-hash');

				jQuery(source)
					.hide();

				jQuery(source)
					.attr('id', 'video-parent-' + hash)
				;

				jQuery('.video-ghost', source)
					.find( '.video-container')
					.attr('id', 'video-container-' + hash)
				;

				jQuery('.video-preview')
					.css('background-image', 'none')
				;

				jQuery('.video-ghost', source)
					.addClass('video')
					.removeClass('video-ghost')
					.attr('id', 'video-' + hash)
					.hide()
					.delay(500)
					.fadeIn()
				;

				jQuery(source)
					.show()
				;
				
				
				
				BASE.progContent = {
						'video_color' : jQuery('.video', v).attr('data-videocolor'),
						'mediatype' : jQuery('.video', v).attr('data-mediatype'),
						'image' : jQuery('.video', v).attr('data-fallbackimage'),
						'ytid' : jQuery('.video', v).attr('data-ytid'),
						'vmid' : jQuery('.video', v).attr('data-vmid'),
						'vmlive' : jQuery('.video', v).attr('data-vmlive'),
						'zmid' : jQuery('.video', v).attr('data-zmid'),
						'zmpwd' : jQuery('.video', v).attr('data-zmpwd'),
						'plid' : jQuery('.video', v).attr('data-plid'),
				};


				BASE.placeVideoContent_v2();
			});
			
			
			
		} else {
			BASE.contentId = jQuery(this).data('id'); // Click
			var contentId = (BASE.contentId !== undefined) ? BASE.contentId : jQuery('.programm-item:first .link-text').data('id');
			var hash = jQuery(this).data('hash');

			if (hash !== undefined) { 
				source = jQuery('.programm-item.item-' + contentId + ' .video-parent-ghost.' + hash);
			
			} else { // First run and JS Click trigger + FB 
				source = jQuery('.programm-item.item-' + contentId + ' .video-parent-ghost');
				hash = jQuery('.video-ghost', source).attr('data-hash');

			}


			jQuery('.video-parent')
				.hide();

			jQuery('.video-parent')
				.html( source.html() )
				.attr('id', 'video-parent-' + hash)
			;

			jQuery('.video-parent .video-ghost')
				.find( '.video-container')
				.attr('id', 'video-container-' + hash)
			;

			jQuery('.video-preview')
				.css('background-image', 'none')
			;

			jQuery('.video-parent .video-ghost')
				.addClass('video')
				.removeClass('video-ghost')
				.attr('id', 'video-' + hash)
				.hide()
				.delay(500)
				.fadeIn()
			;

			jQuery('.video-parent')
				.show()
			;
				
				
				
			BASE.progContent = {
					'video_color' : jQuery(' .video').attr('data-videocolor'),
					'mediatype' : jQuery(' .video').attr('data-mediatype'),
					'image' : jQuery(' .video').attr('data-fallbackimage'),
					'ytid' : jQuery(' .video').attr('data-ytid'),
					'vmid' : jQuery(' .video').attr('data-vmid'),
					'vmlive' : jQuery(' .video').attr('data-vmlive'),
					'zmid' : jQuery(' .video').attr('data-zmid'),
					'zmpwd' : jQuery(' .video').attr('data-zmpwd'),
					'plid' : jQuery(' .video').attr('data-plid'),
			};


			BASE.placeVideoContent_v2();
		}
		
	},



	placeVideoContent_v2: function(){
		var img = '';
		var data = BASE.progContent;
			
		jQuery('.video .video-play').removeClass('vimeo youtube padlet zoom zoom-api').addClass(data.mediatype );



		if (typeof data.video_color !== 'undefined' && data.video_color !== '') {
			jQuery('.video').css('border-color', data.video_color );
			jQuery('.video .video-play').css('background-color', data.video_color );
			jQuery('.video .video-info .content > *, .video .video-info .content header > *, .video .video-info > *').css('color', data.video_color );
			jQuery('.video .video-info .video-format').css({'background-color': data.video_color, 'color' : 'white' });
		} else {
			jQuery('.video').css('border-color', '' );
			jQuery('.video .video-play').css('background-color', '' );
			jQuery('.video .video-info .content > *, .video .video-info .content header > *, .video .video-info > *').css('color', '' );
		}

		if (data.mediatype == 'youtube') {
			if (data.ytid != '') {
				img = 'https://i3.ytimg.com/vi/'+data.ytid+'/maxresdefault.jpg';
			} else if (data.image != '') {
				img = data.image;
				jQuery('.video .video-play').hide();
			}
			
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');

		} else if (data.mediatype == 'vimeo') {
			if (data.vmlive == true ){
				img = data.image;
				jQuery('.video-preview').css('background-image', 'url(' + img + ')');

			} else{
				if ( data.vmimg ) {
					jQuery('.video-preview').css('background-image', 'url(' + data.vmimg + ')');
				} else {
					img = data.image;
					jQuery('.video-preview').css('background-image', 'url(' + img + ')');
				}
			}
			
		} else if (data.mediatype == 'zoom' ) {
			img = data.image;
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');
		
		} else if (data.mediatype == 'zoom-api') {
			jQuery('.video .video-play').attr('data-zmid', data.zmid);
			jQuery('.video .video-play').attr('data-zmpwd', data.zmpwd);

			img = data.image;
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');

			var html = '';
			html += '<div class="zoom-info is-size-7">';
				
				if ( BrowserDetect.OS.search("iPhone") >= 0  ) {
					html += '<p>Your ' + BrowserDetect.OS + ' do not support the Zoom-Integration. Please use the ZoomApp and the following link:</p>';
				} else if ( BrowserDetect.browser == 'Safari' ){
					html += '<p>Your ' + BrowserDetect.browser + ' do not support the Zoom-Integration. Please use the ZoomApp and the following link.</p>';
				} else{
					html += 'Meeting Link:<br />';
				}
				
				html += '<a href="https://us04web.zoom.us/j/' + data.zmid + '?pwd=' + data.zmpwd + '" target="_blank">https://us04web.zoom.us/j/' + data.zmid + '?pwd=' + data.zmpwd + '</a>';
			html += '</div>';

			jQuery('.video-play.zoom-api .zoom-info').remove();
			
			(typeof data.zmid !== 'undefined' ) ? jQuery('.video-play.zoom-api').append(html) : '';
		} 


		BASE.loadVideoContent_v2();

	},



	loadVideoContent_v2: function(){
	    var video = jQuery('.video');
	    video
	    	.removeClass('is-active')
	    	.removeClass('is-playing')
	    ;

	    if ( BASE.progContent.mediatype != 'zoom' || jQuery('body').width() >= BASE.breakpoint )	// prevent player on Zoom AND Mobile
	    	video.addClass('is-active');


	    if ( jQuery('body').width() <= BASE.breakpoint ) {
	      	$this = jQuery('.programm-item .link-video.is-active');

	      	jQuery('.programm-item .video-parent')
	        	// .remove()
	        	.hide();

	      	$this
	        	.closest('.programm-item')
	        	.append( jQuery('.video-parent') )
	    	;

	      	$this
	        	.closest('.programm-item')
	        	.find('.video-parent')
	        	.fadeIn()
	        	;
    	}
	},



	setVideoContent: function(){
		BASE.contentId = jQuery(this).data('id');

		jQuery('.video .is_media').remove();
		jQuery('.video-info').removeClass('is-hidden');
		jQuery('.video-info').hide();
		jQuery('.video .video-info .entry-meta').hide();
		jQuery('.video-sponsor span').hide().text('');
		jQuery('.video .video-sponsor-content img').remove();
		jQuery('.video-sponsor').removeClass('is-hidden');
		jQuery('.video-play').removeClass('is-hidden');
		jQuery('.video-preview').hide().css('background-image', '');
		jQuery('.video .video-play').show();
		jQuery('.video-container').replaceWith('<div id="video-container" class="video-container"></div>');

		BASE.getVideoContent();
	},



	getVideoContent: function(){
		if (typeof kdkJSloadPosttype !== 'undefined')
			kdkJS.postName = kdkJSloadPosttype;
		
		if (typeof kdkSponsor !== 'undefined')
			kdkJS.postName = 'sponsoren';

		if (typeof kdkArchive !== 'undefined')
			kdkJS.postName = 'lounge';
		

		var contentId = (BASE.contentId !== undefined) ? BASE.contentId : jQuery('.programm-item .link-text').data('id');


		if (typeof contentId === 'undefined' && kdkJS.postName != 'support' )
			return;


		fetch(kdkJS.url + '/wp-json/wp/v2/' + kdkJS.postName + '/' + contentId + '/')
			.then(response => {
				return response.json()
			})
			.then(data => {
				// console.log(data);
				BASE.progContent = data;
				BASE.placeVideoContent();
			})
			.catch(err => {
				console.log('Video Content not loaded');
		});
	},



	placeVideoContent: function(){
		var img = '';
		
		if( typeof kdkJSloadPosttype !== 'undefined' && kdkJSloadPosttype == 'support' ){
			var data = {
							'mediatype' : kdkJS.mediatypes,
							'ytid' : kdkJS.ytids,
							'vmid' : kdkJS.vmids,
							'vmlive' : kdkJS.vmlive,
							'vmimg' : kdkJS.vmimg,
							'video_color' : kdkJS.videoscolor,
							'image' : kdkJS.image,
						};

			jQuery('.video .video-title').html(kdkJS.videostitle);
			jQuery('.video .video-play').removeClass('vimeo youtube padlet zoom zoom-api').addClass(data.mediatype );

		} else {
			var data = BASE.progContent;
			
			console.log(data);
			
			
			
			jQuery('.video .video-begin').html( (data.begin) ? data.begin + ' Uhr' : '');
			jQuery('.video .video-end').html( (data.end) ? data.end + ' Uhr' : '');
			jQuery('.video .video-format').html(data.format);
			jQuery('.video .video-speaker').html('');
			(Array.isArray(data.host)) ? data.host.forEach(element => jQuery('.video .video-speaker').append(element.name + '<br />')) : '';
			(typeof data.yttitle !== 'undefined') ? jQuery('.video .video-title').html(data.yttitle) : jQuery('.video .video-title').html(data.title.rendered);
			(typeof data.sponsor_gradient !== 'undefined') ? jQuery('.video .video-sponsor').css({'background-image': "linear-gradient(" + data.sponsor_gradient + ")" }) : '';
			jQuery('.video .video-play').removeClass('vimeo youtube padlet zoom zoom-api').addClass(data.mediatype );
			
			if (typeof data.sponsor_text !== 'undefined' && data.sponsor_text !== '') {
				jQuery('.video .video-sponsor span').html(data.sponsor_text).fadeIn();
			}

			if (typeof data.sponsor_logo !== 'undefined' && data.sponsor_logo !== '') {
				jQuery('.video .video-sponsor-content').prepend('<img src="' + data.sponsor_logo + '" class="sponsor-logo" />');
			}
		}


		if (typeof data.video_color !== 'undefined' && data.video_color !== '') {
			jQuery('.video').css('border-color', data.video_color );
			jQuery('.video .video-play').css('background-color', data.video_color );
			jQuery('.video .video-info .content > *, .video .video-info .content header > *, .video .video-info > *').css('color', data.video_color );
			jQuery('.video .video-info .video-format').css({'background-color': data.video_color, 'color' : 'white' });
		} else {
			jQuery('.video').css('border-color', '' );
			jQuery('.video .video-play').css('background-color', '' );
			jQuery('.video .video-info .content > *, .video .video-info .content header > *, .video .video-info > *').css('color', '' );
			// jQuery('.video .video-info').css('border-color', '' );
		}

		if (data.mediatype == 'youtube') {
			jQuery('.video .video-play').attr('data-ytid', data.ytid);

			if (data.ytid != '') {
				img = 'https://i3.ytimg.com/vi/'+data.ytid+'/maxresdefault.jpg';
			} else if (data.image != '') {
				img = data.image;
				jQuery('.video .video-play').hide();
			}
			
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');

		} else if (data.mediatype == 'vimeo') {
			jQuery('.video .video-play').attr('data-vmid', data.vmid);
			jQuery('.video .video-play').attr('data-vmlive', data.vmlive);
			jQuery('.video .video-preview').css('background-color', 'black');

			if (data.vmlive == true ){
				img = data.image;
				jQuery('.video-preview').css('background-image', 'url(' + img + ')');

			} else{
				if ( data.vmimg ) {
					jQuery('.video-preview').css('background-image', 'url(' + data.vmimg + ')');
				} else {
					// jQuery.getJSON('https://www.vimeo.com/api/v2/live/' + data.vmid + '.json?callback=?', {format: "json"}, function(data) {
					//     img = data[0].thumbnail_large;
					// 	jQuery('.video-preview').css('background-image', 'url(' + img + ')');
					// });
					img = data.image;
					jQuery('.video-preview').css('background-image', 'url(' + img + ')');
				}
			}
			
		} else if (data.mediatype == 'zoom' ) {
			img = data.image;
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');
		
		} else if (data.mediatype == 'zoom-api') {
			jQuery('.video .video-play').attr('data-zmid', data.zmid);
			jQuery('.video .video-play').attr('data-zmpwd', data.zmpwd);

			img = data.image;
			jQuery('.video-preview').css('background-image', 'url(' + img + ')');

			var html = '';
			html += '<div class="zoom-info is-size-7">';
				
				if ( BrowserDetect.OS.search("iPhone") >= 0  ) {
					html += '<p>Your ' + BrowserDetect.OS + ' do not support the Zoom-Integration. Please use the ZoomApp and the following link:</p>';
				} else if ( BrowserDetect.browser == 'Safari' ){
					html += '<p>Your ' + BrowserDetect.browser + ' do not support the Zoom-Integration. Please use the ZoomApp and the following link.</p>';
				} else{
					html += 'Meeting Link:<br />';
				}
				
				html += '<a href="https://us04web.zoom.us/j/' + data.zmid + '?pwd=' + data.zmpwd + '" target="_blank">https://us04web.zoom.us/j/' + data.zmid + '?pwd=' + data.zmpwd + '</a>';
			html += '</div>';

			(typeof data.zmid !== 'undefined' ) ? jQuery('.video-play.zoom-api').append(html) : '';
		} 

		if (data.mediatype == 'padlet') {
			(typeof data.plid !== 'undefined' ) ? jQuery('.video').append('<div class="is_media"><iframe src="https://padlet.com/embed/' + data.plid + '" frameborder="0" allow="camera;microphone;geolocation" style="width:100%;height:100%;"></iframe></div>') : '';
		

			
			
			

		} else {
			if ( data.begin || data.fromat ) 
				jQuery('.video .video-info .entry-meta').fadeIn();
			
			jQuery('.video .video-info').fadeIn();
			jQuery('.video .video-preview').fadeIn();
		}



		// if( jQuery( '.page-support' ).length < 1){
			BASE.loadVideoContent();
		// }
	},



	loadVideoContent: function(){
	    var video = jQuery('.video');
	    var ytid = BASE.progContent.ytid;
	    var vmid = BASE.progContent.vmid;

	    // if ( jQuery('body').width() <= BASE.breakpoint ) jQuery('html, body').css('overflow-y', 'hidden');
	    
	    video
	    	.removeClass('is-active')
	    	.removeClass('is-playing')
	    	.data('ytid', ytid)
	    	.data('vmid', vmid);


	    if ( ytid || vmid || jQuery('body').width() >= BASE.breakpoint )	// prevent player on Zoom AND Mobile
	    	video.addClass('is-active');
	},


	
	setProgContent_v2: function(){
		BASE.contentId = jQuery(this).data('id'); // Click

		var contentId = (BASE.contentId !== undefined) ? BASE.contentId : jQuery('.programm-item:first .link-text').data('id');

		jQuery('.text')
			.hide();

		jQuery('.programm-content-wrap:not(.ghost)')
			.html( jQuery('.programm-item.item-' + contentId + ' .programm-content-wrap').html())
			.show()
			;
			
		jQuery('.programm-content-wrap:not(.ghost) .button.trigger-close').remove();

		if ( jQuery('body').width() >= BASE.breakpoint ) {
			jQuery('.text')
				.fadeIn()
					;
		}
	},



	setProgContent: function(){
		BASE.contentId = jQuery(this).data('id');

		jQuery('.programm-content-wrap').hide();
		
		BASE.getProgContent();

		// jQuery(this).parent().find('.is-yt').trigger('click');
	},



	getProgContent: function(){
		if (typeof kdkJSloadPosttype !== 'undefined')
			kdkJS.postName = kdkJSloadPosttype;

		if (typeof kdkArchive !== 'undefined')
			kdkJS.postName = 'lounge';
		
		var contentId = (BASE.contentId !== undefined) ? BASE.contentId : jQuery('.programm-item .link-text').data('id');

		if (contentId === undefined)
			return;
		
		fetch(kdkJS.url + '/wp-json/wp/v2/' + kdkJS.postName + '/' + contentId + '/')
			.then(response => {
				return response.json()
			})
			.then(data => {
				// console.log(data);
				BASE.progContent = data;
				BASE.placeProgContent();
			})
			.catch(err => {
				// console.log(err);
				console.log('Programm Content not loaded');
		});
	},



	placeProgContent: function(){
		var data = BASE.progContent;
		( data.begin != '' || data.end != '' ) ? jQuery('.text .entry-meta').show() : jQuery('.text .entry-meta').hide();
		jQuery('.programm-begin').html( (data.begin) ? data.begin + ' Uhr' : '');
		jQuery('.programm-end').html( (data.end) ? data.end + ' Uhr' : '');
		jQuery('.programm-title').html(data.title.rendered);
		jQuery('.programm-speaker').html('');
		(Array.isArray(data.host)) ? data.host.forEach(element => jQuery('.programm-speaker').append(element.name + '<br />')) : '';
		jQuery('.programm-content').html(data.content.rendered);

		jQuery('.programm-content-wrap').fadeIn();
	},



	initSlick: function(){
		jQuery(window).on('resize orientationChange', function() {
		    if ( jQuery('.slider').length >= 1 ) {
		      jQuery('.slick-slider').slick('refresh'); /* refresh existing sliders */

		      if ( jQuery(window).width() <= 768 ) {
		        // jQuery('.slider:not(.slick-slider)').slick(); /* slickfy uninitialized mobile sliders */
		        jQuery('.slick-slider').slick('unslick');
		      } else {
		        var $sliders = jQuery('.slider:not(.slick-slider)').slick(); /* slickfy uninitialized sliders */
		      }
		    }
		 }).trigger('resize');
	},



	showProgNav: function(){
		jQuery('.menu .layer')
			.css({'top': jQuery('header.header').outerHeight() + 'px'})
			.toggle();

		jQuery('#burger, #main-navigation').removeClass('open');

		jQuery('.menu .programm').toggleClass('open');


		return false;
	},



	showMobileNav: function(){
		jQuery('#burger').toggleClass('open');

		jQuery('.is-menu-programm')
			.toggleClass('open')
		;

		// jQuery('.menu .layer').hide();
		// jQuery('.menu .programm').removeClass('open');

		// jQuery('#main-navigation')
		// 	.toggleClass('open')
		// 	.css({'top': jQuery('header.header').outerHeight() + 'px'})

		// return false;
	},



	triggerProgNav: function(){
		if ( ! jQuery(this).hasClass('has-sublayer') )
			jQuery(this).trigger('click');
	},



	setProgNav: function(){
		var pathArray 	= window.location.href.split('/');
		var slug 		= pathArray.slice(-2)[0] 
		var title 		= jQuery('.menu .layer a[data-slug="' + slug + '"]').text();
		var isSponsor 	= window.location.href.match(/sponsor/g);

		jQuery('.menu a.programm .title').text(title);
	},



	showProgSubLayer: function(){
		jQuery(event.target).toggleClass('open');
		jQuery(event.target).next().slideToggle().toggleClass('open');

		// simpleBar.recalculate();

		return false;
	},


	setMobileProgNav: function(){
		// jQuery('ul#main-navigation').addClass('open');
		jQuery('header.main-menu').prepend('<div class="tile is-menu-mobile"></div>');
		jQuery('header.main-menu .is-menu-mobile')
			.prepend(jQuery('header.main-menu #burger') )
			.prepend(jQuery('header.main-menu .is-menu-programm') )
			.prepend('<div class="menu-title">' + kdkJS.blogname + '</div>' );
		;

		SPONSOR.initProgrammSponsorMenu();

		jQuery.each(jQuery('header.main-menu #main-navigation a'), function(i,v){
			jQuery(v).addClass('layer-item');
			jQuery('header.main-menu .is-menu-mobile .is-menu-programm').append(v);
		});

		jQuery('header.main-menu .programm')
			.removeClass('menu-item')
			.removeClass('programm')
			.removeClass('has-subnav')
			.addClass('layer-item')
			.addClass('has-sublayer')
		;
		
		jQuery('header.main-menu .menu').remove();

		jQuery('header.main-menu .is-menu-mobile .layer').removeClass('has-scrollbars');
		jQuery('header.main-menu .is-menu-mobile .is-menu-programm').addClass('has-scrollbars'); // not necessary
		jQuery('header.main-menu .is-menu-mobile .is-menu-programm').css('max-height', 'calc(100vh - ' + jQuery('header.header').outerHeight() + 'px)');
		
		setTimeout(function(){
			simpleBar = new SimpleBar(jQuery('header.main-menu .is-menu-mobile .is-menu-programm')[0] );
		}, 500);
		
		
		
		
	},
}







var UPDATE = {
	onReady: function(){
		// setInterval(UPDATE.ticker, 120000);
		// setInterval(UPDATE.program, 180000);
	},



	ticker: function(){
		if ( jQuery('.ticker').length < 1 )
			return;

		UPDATE.def = new jQuery.Deferred();
		UPDATE.getTicker();

		jQuery.when(UPDATE.def).then(function(){
			var json = JSON.parse(UPDATE.tickerResponse);
        	var ticker = jQuery('.ticker .ticker-text a').html();

        	if( ticker != json.text)
        		jQuery('.ticker .ticker-text a').html(json.text);

        	jQuery('.ticker').css( "color", json.text_color );
        	jQuery('.ticker').css( "background-color", json.bg_color );
    	});
        	
	},



	getTicker : function(){
		jQuery.ajax({
            url: kdkJS.ajaxurl,
            type:'POST',
            data: "action=get_ticker", 
            success: function(response){
            	var regex    = new RegExp(/[0]$/);
				var response = response.replace(regex, '');
            	// console.log(response);
            	if(response == 'false'){
            		UPDATE.tickerResponse = response;
            		return UPDATE.def.resolve();

            	} else {
            		UPDATE.tickerResponse = response;
            		return UPDATE.def.resolve();
            	}
            },
            error : function(jqXHR, textStatus, errorThrown){
                console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            }
        });
	},



	program: function(){
		if ( jQuery('.programm-item').length < 1 )
			return;
		
		UPDATE.pDef = new jQuery.Deferred();
		UPDATE.getProgram();

		jQuery.when(UPDATE.pDef).then(function(){
			var json = JSON.parse(UPDATE.programResponse);

			json.forEach(function(v,i){
				var e = jQuery('.programm-item .actions a.link-video[data-id="'+v.id+'"]');
				
				if ( v.zoom != '' ){
					e
						.attr('href', v.zoom)
						.attr('target', '_blank')
						.removeClass('is-yt')
						.addClass('is-zoom');
				
				} else {
					e
						.attr('href', '#player-'+v.id)
						.attr('target', '_blank')
						.attr('data-ytid', v.yt)
						.removeClass('is-zoom')
						.addClass('is-yt');
				}
			});
    	});
        	
	},



	getProgram : function(){
		jQuery.ajax({
            url: kdkJS.ajaxurl,
            type:'POST',
            data: "action=get_program", 
            success: function(response){
            	var regex    = new RegExp(/[0]$/);
				var response = response.replace(regex, '');
            	// console.log(response);
            	if(response == 'false'){
            		UPDATE.programResponse = response;
            		return UPDATE.pDef.resolve();

            	} else {
            		UPDATE.programResponse = response;
            		return UPDATE.pDef.resolve();
            	}
            },
            error : function(jqXHR, textStatus, errorThrown){
                console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            }
        });
	},
}







var FORMS = {
	onReady: function(){
		jQuery(document).on('click', '.has-registration-form #trigger-signoff', FORMS.initSignoff);
		jQuery(document).on('click', '.form-lead #kdk-submit', FORMS.initSubmit);
		jQuery(document).on('blur', '#form-lead-registration input[name="kdk-email"]', FORMS.checkUseremail);
		jQuery(document).on('blur', '#form-lead-registration input[name="kdk-password"], #form-lead-registration input[name="kdk-password-repeat"]', FORMS.checkPassword);
		jQuery(document).on('blur', '#form-lead-registration input[name="kdk-password"]', FORMS.checkPassword);
	},



	initSubmit: function(){
		if(jQuery('form.form-lead').length < 1 )
			return;
		
		FORMS.context 	= jQuery(this).closest('form');
		FORMS.formname 	= jQuery('input[name=kdk-form-name]', FORMS.context).val();
		jQuery('.notification').remove();

		FORMS.DEFvalidation = new jQuery.Deferred();

		FORMS.validateForm();

		jQuery.when(FORMS.DEFvalidation).then(function(){
			if(FORMS.error < 1)
				FORMS.sendForm();
		});

		return false;
	},



	validateForm: function(){
		FORMS.error = 0;
		jQuery.each(jQuery('input.required, select.required, textarea.required', FORMS.context), function(i,v){
			jQuery(v).removeClass('is-danger');
			jQuery(v).parent().find('p.is-danger').remove();

			if (jQuery(v).prop('nodeName') == 'SELECT') {
				if(jQuery('option:selected', v).val() == false) {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}

			} else if (jQuery(v).attr('type') == 'email') {
				var regex = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
				
				if(regex.test(jQuery(v).val()) == false || jQuery(v).val() == '') {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}
				
			} else if (jQuery(v).attr('type') == 'checkbox'){				
				if(!jQuery(v).prop('checked')) {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}

			} else if (jQuery(v).attr('type') == 'radio') {
				if(jQuery('[name="' + jQuery(v).attr('name') + '"]:checked').length == 0 && jQuery.inArray(jQuery(v).data('errormsg'), FORMS.error) == -1) {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}
				
			} else if (jQuery(v).attr('type') == 'text') {
				if(jQuery(v).val() == '') {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}

			} else if (jQuery(v).attr('type') == 'submit') {
				console.log('submit');
				
			} else {
				if(jQuery(v).val() == '') {
					var msg = jQuery(v).data('errormsg');
					jQuery(v).addClass('is-danger');
					jQuery(v).parent().append('<p class="help is-danger">' + msg + '</p>');
					FORMS.error++;
				}
			}
		});

		return FORMS.DEFvalidation.resolve();
	},



	sendForm: function(){
		var formData = jQuery(FORMS.context).serialize();

		jQuery.ajax({
		    type: 'POST',
		    url: kdkJS.ajaxurl,
		    data: formData,
	        success: function (response, textStatus, XMLHttpRequest) {
	        	var regex    = new RegExp(/[0]$/);
				var response = jQuery.trim(response.replace(regex, ''));
				var resJson;
				var tpl = '';

				console.log(response);

				try {
					var resJson = jQuery.parseJSON( response );
				} catch(e) {
	            	jQuery(FORMS.context).after('<br /><br /><div class="notification is-danger"><p>' + objectL10n.error_simple + '.</p></div>');
				}

				if (typeof resJson.error !== 'undefined' && resJson.error.length >= 1) {
					tpl += '<br /><br /><div class="notification is-danger" style="display: none">';
						jQuery.each( resJson.error, function(i,v){
							tpl += '<p>' + v + '</p>'; 
						});
					tpl += '</div>';
				} 

				if (typeof resJson.success !== 'undefined' && resJson.success.length >= 1) {
					if (resJson.success == 'registration-success' ) {
						FORMS.registrationSuccess();

						return;
					} else {
						tpl += '<br /><br /><div class="notification is-success contact success" style="display: none">';
							jQuery.each( resJson.success, function(i,v){
								tpl +=  v; 
							});
						tpl += '</div>';
					}
				}


				console.log(resJson.success);
				
				
				
	            jQuery(FORMS.context)
	            	.after(tpl)
	            	.fadeOut(function(){
			            jQuery('.notification').fadeIn();
			            jQuery(FORMS.context).remove();

	            	});

	   //          if(!resJson.error)
	   //          	setTimeout(function() {window.location.href = azJS.url + '/uebertragung-erfolgreich/kdk/' + FORMS.formname + '/'}, 1000);
	        },
	        error: function (XMLHttpRequest, textStatus, errorThrown) {
	            console.log('Server error: ' + errorThrown);
	        }
	    });
	},


		
		
	registrationSuccess: function(){
		FORMS.context.closest('.tile').find('p.title').text(objectL10n.reg_headline);
		FORMS.context.closest('.has-registration-form')
			.addClass('has-background-success');
		jQuery('#footer-navigation')
			.addClass('has-background-success')
			.removeClass('has-background-grey-light');

		let tpl = '<p class="info has-text-centered"  style="display: none">' + objectL10n.reg_thankyou + '</p><br />';
			tpl += '<p class="info has-text-centered"  style="display: none">' + objectL10n.reg_text + '</p>';

		jQuery(FORMS.context)
	            	.after(tpl)
	            	.fadeOut(function(){
			            jQuery('.info').fadeIn();
			            jQuery(FORMS.context).remove();

	            	});
	},



	checkUseremail: function(){
		FORMS.usermail = jQuery(this);
		jQuery('.is-danger.is-usermail', FORMS.context).remove();
		FORMS.usermail.removeClass('is-danger');
		
		jQuery.ajax({
		    type: 'POST',
		    url: kdkJS.ajaxurl,
		    data: 'action=check_useremail&email=' + jQuery(this).val(),
	        success: function (response, textStatus, XMLHttpRequest) {
	        	var regex    = new RegExp(/[0]$/);
				var response = jQuery.trim(response.replace(regex, ''));

				if (response == 'true') {
					var msg = FORMS.usermail.data('errormsg');
					FORMS.usermail.addClass('is-danger');
					jQuery('.help', FORMS.usermail.parent()).remove();
					FORMS.usermail.parent().append('<p class="help is-danger is-usermail">' + objectL10n.reg_error_email + '</p>');
				}
				console.log(response);
	        },
	        error: function (XMLHttpRequest, textStatus, errorThrown) {
	            console.log('Server error: ' + errorThrown);
	        }
	    });
	},



	checkPassword: function(){
		let pass = jQuery('input[name="kdk-password"]');
		let repeat = jQuery('input[name="kdk-password-repeat"]');

		repeat.parent().find('.help').remove();

		if (pass.val() != repeat.val() )
			repeat.parent().append('<p class="help is-danger">' + repeat.data('errormsg') + '</p>');
	},



	initSignoff: function(){
		var login = jQuery(this).attr('data-login');

		jQuery.ajax({
		    type: 'POST',
		    url: kdkJS.ajaxurl,
		    data: 'action=registration_signoff&login=' + login,
	        success: function (response, textStatus, XMLHttpRequest) {
	        	var regex    = new RegExp(/[0]$/);
				var response = jQuery.trim(response.replace(regex, ''));

				console.log(response);
				
				jQuery('#signoff').fadeOut(function(){
					jQuery('#signoff')
						.html(response)
						.fadeIn();
				});
				
			},
	        error: function (XMLHttpRequest, textStatus, errorThrown) {
	            console.log('Server error: ' + errorThrown);
	        }
	    });
	}
};




var MEDIAUPLOAD = {
	onReady: function(){
		if(jQuery('.media-uploader').length < 1)
			return;

		MEDIAUPLOAD.testBrowerSupport();

		jQuery('.trigger-file-select').on('click', MEDIAUPLOAD.triggerFileSelect);
		jQuery('.media-uploader input[type="file"]').on('change', MEDIAUPLOAD.upload);
	},



	testBrowerSupport: function(){
		if (window.File && window.FileReader && window.FileList && window.Blob)
			jQuery('body').addClass('file-api-ready');

		else
			jQuery('.trigger-file-select').after('<div class="notification is-error" role="alert">Dieser Browser untertsützt leider keine moderne Technologie zum Hochladen von Dateien.</div>');
	},



	triggerFileSelect: function(){
		jQuery(jQuery(this).data('target')).click();

		return false;
	},



	upload : function(){
		var file = this.files[0];
		var formname = jQuery(this).closest('form').find('input[name="kdk-form-name"]').val();

		jQuery('#progress .loader').css({'width' : '0%'});
		jQuery('.media-uploader .notification').remove();
		
	    console.log("name : " + file.name);
	    console.log("size : " + file.size);
	    console.log("type : " + file.type);
	    console.log("date : " + file.lastModified);

	    if (file.type == 'application/pdf' && file.size <= 10000000) {
			console.log('its a PDF');

		    jQuery('.trigger-file-select').hide();
		    jQuery('#progress').show();

		    var formdata = new FormData();
		    formdata.append("media-file", file);
	    	formdata.append("action", "poll_upload_mediafile");
	    	formdata.append("kdk-form-name", formname);

	    	var xhr = new XMLHttpRequest();

	    	// progress bar
			xhr.upload.addEventListener("progress", function(e) {
				var pc = parseInt(e.loaded / e.total * 100);
				jQuery('#progress .loader').css({'width' : pc + '%'});
			}, false);


			// file received/failed
			xhr.onreadystatechange = function(e) {
				// console.log(xhr);
				if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
					var regex    = new RegExp(/[0]$/);
					var response = jQuery.trim(xhr.responseText.replace(regex, ''));

					console.log(response);
					
					
					
			    	jQuery('#progress').hide();
					if(response != ''){
						jQuery('.trigger-file-select').after('<input type="hidden" name="kdk-poll[Media File]" value="' + response + '">');
						jQuery('.trigger-file-select').after('<div class="notification is-error" role="alert">File transferred successfully: ' + file.name + '</div>');
					} else {
						jQuery('.trigger-file-select').after('<div class="notification is-warning" role="alert">Fehler bei der Übertragung.</div>');
						jQuery('.trigger-file-select').show();
					}
				}
			};

			// start upload
			xhr.open("POST", kdkJS.ajaxurl, true);
			xhr.send(formdata);

	    } else {
	    	if (file.type != 'application/pdf'){
				jQuery('.trigger-file-select').after('<div class="notification is-warning" role="alert">Dieser Dateityp wird nicht unterstützt.</div>');
	    	}
	    	
	    	if (file.size > 10000000) {
				jQuery('.trigger-file-select').after('<div class="notification is-warning" role="alert">Die Datei ist zu groß.</div>');
	    	}

		}
	}
}





var TOGGLE = {
	onReady: function(){
		if(jQuery('.toggle-trigger').length < 1 )
			return;
		

		TOGGLE.initToggle();

		jQuery(document).on('change', '.toggle-trigger', TOGGLE.toggle);
	},



	initToggle: function( e ) {
		jQuery('.toggle-target').hide();

		jQuery.each(jQuery('.toggle-trigger'), function(i,v){
			TOGGLE.toggle(v);
		});
	},



	toggle: function( e ) {
		let el = ( e.target ) ? jQuery(e.target) : jQuery(e);

		if ( el.is('select') ) {
			jQuery(el).closest('.field').find('.toggle-target').hide();
			( jQuery('option:selected', el).val() != '' ) ? jQuery(el).closest('.field').find('.toggle-target.' + jQuery('option:selected', el).val()).fadeIn() : '';
			
		} else {
			if ( el.prop('checked') ){
				jQuery(el).closest('.control').find('.toggle-target').hide();
				jQuery(el).closest('.control').find('.toggle-target.' + el.val()).fadeIn();
			} else {
				jQuery(el).closest('.control').find('.toggle-target').hide();

			}
		}
	}
}



